import React, { useMemo } from "react";
import { Radar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

const DynamicRadarChart = ({ data }) => {
  // 🔍 Debugging (you can remove later)
  console.log("DynamicRadarChart received data:", data);

  // ✅ Guard for invalid data
  const hasValidData =
    data &&
    data.chartData &&
    Array.isArray(data.chartData.datasets) &&
    data.chartData.datasets.length > 0 &&
    Array.isArray(data.chartData.labels) &&
    data.chartData.labels.length > 0;

  const options = useMemo(
    () => ({
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: "bottom",
          labels: {
            font: { size: 12 },
            color: "#333",
            padding: 15,
          },
        },
        tooltip: {
          backgroundColor: "rgba(0,0,0,0.8)",
          titleFont: { size: 13 },
          bodyFont: { size: 12 },
          callbacks: {
            label: (tooltipItem) =>
              `${tooltipItem.dataset.label}: ${tooltipItem.formattedValue}`,
          },
        },
      },
      scales: {
        r: {
          angleLines: { color: "#ccc" },
          grid: { color: "#ddd" },
          suggestedMin: 0,
          suggestedMax: 5,
          ticks: {
            stepSize: 1,
            color: "#666",
            backdropColor: "transparent",
            font: { size: 11 },
          },
          pointLabels: {
            color: "#222",
            font: { size: 12, weight: "500" },
          },
        },
      },
    }),
    []
  );

  if (!hasValidData) {
    return (
      <div
        style={{
          height: "400px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#999",
        }}
      >
        No radar data available
      </div>
    );
  }

  return (
    <div style={{ width: "100%", height: "400px" }}>
      <Radar data={data.chartData} options={options} />
    </div>
  );
};

export default DynamicRadarChart;
